import { gql } from "@apollo/client";

const GET_PROMO_STATUSES = gql`
  query PromoStatuses {
    promoStatuses {
      items {
        promoStatusId
        promoStatusName
        promoStatusKey
      }
      count
    }
  }
`;

export default GET_PROMO_STATUSES;
